document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {
  var menu = document.querySelector('[data-mobile-menu]');
  var menuButtons = document.querySelectorAll('[data-menu-toggle]');

  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('dd-menu-open', open);
    menuButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var firstLink = menu.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }
  }

  menuButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setMenu(!menu.classList.contains('is-open'));
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu && menu.classList.contains('is-open')) {
      setMenu(false);
    }
  });

  document.querySelectorAll('[data-quantity]').forEach(function (quantity) {
    var input = quantity.querySelector('input[type="number"]');
    if (!input) return;
    quantity.querySelectorAll('[data-quantity-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var current = parseInt(input.value || '1', 10);
        var step = parseInt(input.step || '1', 10);
        var min = parseInt(input.min || '0', 10);
        var next = button.dataset.quantityButton === 'increase' ? current + step : current - step;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var price = root.querySelector('[data-product-price]');
    var compare = root.querySelector('[data-compare-price]');
    var submit = root.querySelector('[data-product-submit]');
    var submitText = root.querySelector('[data-product-submit-text]');
    var variantInputs = root.querySelectorAll('input[name="id"], select[name="id"]');

    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = input.matches('select') ? input.options[input.selectedIndex] : input;
        if (price && selected.dataset.price) price.textContent = selected.dataset.price;
        if (compare) {
          compare.textContent = selected.dataset.comparePrice || '';
          compare.hidden = !selected.dataset.comparePrice;
        }
        var available = selected.dataset.available !== 'false' && !selected.disabled;
        if (submit) submit.disabled = !available;
        if (submitText) submitText.textContent = available ? submitText.dataset.availableText : submitText.dataset.soldText;
      });
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-product-gallery]');
      if (!gallery) return;
      var mainImage = gallery.querySelector('.dd-product-gallery__main img');
      if (!mainImage) return;
      mainImage.src = thumb.dataset.imageSrc;
      mainImage.srcset = thumb.dataset.imageSrcset || '';
      mainImage.alt = thumb.dataset.imageAlt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
});
